import { useMutation } from "@tanstack/react-query";
import taskCustomFieldService from "../api/taskCustomFieldService";

export const useUpdateTaskCustomField = () => {
  const { updateTaskCustomField } = taskCustomFieldService();

  return useMutation({
    mutationKey: ["update-task-custom-field"],
    mutationFn: async ({ taskCustomField }) => {
      const response = await updateTaskCustomField(taskCustomField);
      return response.data;
    },
  });
};
